import axios from "../config/axiosInstance";
import endpoints from "./endpoints";

export const getAllUsers = async (details) => {
  const response = await axios.put(endpoints.getAllUsers, details);
  return response;
};

export const createUser = async (details) => {
  const response = await axios.post(endpoints.createUser, details);
  return response;
};
